let sink = null;
let t0 = 0;
export function record() { sink = []; t0 = performance.now(); return sink; }
export function stop() { sink = null; }
export function step(fn, note) {
    if (sink)
        sink.push({ fn, note, ms: Math.round((performance.now() - t0) * 100) / 100 });
}
